import type { QuoteTaxRepository } from '../../application/QuoteTaxRepository'
import type { QuoteTaxProfile } from '../../domain/quoteTax'

export function createFixtureQuoteTaxRepository(
  source: 'fixtures' | 'fixture-fallback' = 'fixtures',
): QuoteTaxRepository {
  const profiles: QuoteTaxProfile[] = []
  const activations = new Map<string, string>()
  return {
    listProfiles() {
      return Promise.resolve({
        profiles: profiles.map((profile) => ({ ...profile, rates: [...profile.rates] })),
        meta: { source, retrievedAt: new Date().toISOString() },
      })
    },
    activateProfile(command) {
      const existingId = activations.get(command.idempotencyKey)
      const existing = profiles.find((profile) => profile.id === existingId)
      if (existing) {
        return Promise.resolve({
          profileId: existing.id,
          version: existing.version,
          status: existing.status,
          activatedAt: existing.activatedAt,
        })
      }
      for (const profile of profiles) profile.status = 'RETIRED'
      const activatedAt = new Date().toISOString()
      const id = command.idempotencyKey
      const profile: QuoteTaxProfile = {
        id,
        version: profiles.length + 1,
        label: command.label,
        status: 'ACTIVE',
        roundingStrategy: command.roundingStrategy,
        activatedAt,
        rates: command.rates.map((rate, index) => ({
          ...rate,
          id: `${id}-${String(index + 1)}`,
          displayOrder: index + 1,
        })),
      }
      profiles.unshift(profile)
      activations.set(command.idempotencyKey, id)
      return Promise.resolve({
        profileId: id,
        version: profile.version,
        status: profile.status,
        activatedAt,
      })
    },
  }
}
